/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Heading } from 'sarsaparilla';

type ImportantDate = {
    description: string;
    view_order?: string;
    display_order?: string;
    start_date: string;
    end_date: string;
};

type PermitVenueDatesPropTypes = {
    permit: {
        important_dates: Array<ImportantDate>;
    };
    hideTitle?: boolean;
};

export default class PermitVenueDates extends React.Component<PermitVenueDatesPropTypes> {
    renderHeader() {
        return (
            <thead>
                <tr>
                    <th>Dates</th>
                    <th>Information</th>
                </tr>
            </thead>
        );
    }

    renderRow(importantDate: ImportantDate) {
        const {
            description,
            view_order: viewOrder,
            display_order: displayOrder,
            start_date: startDate,
            end_date: endDate,
        } = importantDate;

        const dateDisplayStr = !isEmpty(endDate)
            ? `${startDate} - ${endDate}`
            : `${startDate}`;
        const key = viewOrder || displayOrder || `${Math.random()}`;

        return (
            <tr key={key}>
                <td>{dateDisplayStr}</td>
                <td>{description}</td>
            </tr>
        );
    }

    render() {
        const importantDates = get(this.props.permit, 'important_dates', []);
        if (!importantDates.length) return null;

        return (
            <div id="important-dates">
                {!this.props.hideTitle && (
                    <Heading appearance="h5" headingLevel={2}>
                        Important Dates
                    </Heading>
                )}
                <table title="Permit Venue Dates">
                    <caption className="rec-sr-only">Important Dates</caption>
                    {this.renderHeader()}
                    <tbody>
                        {importantDates.map((d) => {
                            return this.renderRow(d);
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}
